import { toast } from 'react-toastify';

export const handleErrorMessage = (m, _method?: string) => {
    if (m.response && m.response.data && m.response.data.message) {
        toast.error(m.response.data.message);
    } else {
        toast.error(m.toString());
    }
};
